import { sortBy, get } from 'lodash';

export const strict = false;
export const type = 'template';

export const GET = 'GET';
export const TEMPLATE = 'TEMPLATE';
export const DEMO_TEMPLATE_QUESTIONS = 'DEMO_TEMPLATE_QUESTIONS';
const SET_TEMPLATE = 'SET_TEMPLATE';
const SET_DEMO_TEMPLATE_QUESTIONS = 'SET_DEMO_TEMPLATE_QUESTIONS';

export const state = () => ({
  data: {},
  demoTemplateQuestions: []
});

export const actions = {
  async [GET]({
    getters, state, commit, error
  }, { slug, eventTypeSlug }) {
    try {
      const response = await this.$axios.$get(
        `api/v1/appointments/info${window.location.search}`,
        { params: { slug, event_type_slug: eventTypeSlug } }
      );

      commit(SET_TEMPLATE, response);
      commit(SET_DEMO_TEMPLATE_QUESTIONS, response.data.attributes);

      return true;
    } catch (err) {
      if (get(err, ['response', 'status']) === 404) {
        this.$router.push({ name: 'pageNotFound' });
      } else {
        this.$sentry.captureException(err);
        console.error('caught', err);
      }

      return false;
    }
  }
};

export const mutations = {
  [SET_TEMPLATE](state, { data }) {
    state.data = data;
  },
  [SET_DEMO_TEMPLATE_QUESTIONS](state, { demoTemplateQuestions }) {
    state.demoTemplateQuestions = demoTemplateQuestions;
  }
};

export const getters = {
  [TEMPLATE](state, getters) {
    return state.data.attributes
      ? { ...state.data.attributes, id: state.data.id }
      : {};
  },
  [DEMO_TEMPLATE_QUESTIONS](state, getters) {
    return sortBy(state.demoTemplateQuestions, 'position');
  }
};
